import { Suspense, lazy, useState } from "react";
import { LetterbookSettingType } from "features/Letterbooks/types";
import InactiveAddNewColumnButton from "./InactiveAddNewColumnButton";

const ActiveAddNewColumnButton = lazy(
  () => import("./ActiveAddNewColumnButton")
);

export default function AddNewColumn({
  settings,
}: {
  settings: LetterbookSettingType;
}) {
  const [clicked, setClicked] = useState(false);

  // No more columns to show
  if (settings.unusedColumns.length === 0) {
    return false;
  }

  return (
    <>
      {clicked ? (
        <Suspense fallback={<InactiveAddNewColumnButton loading />}>
          <ActiveAddNewColumnButton settings={settings} />
        </Suspense>
      ) : (
        <InactiveAddNewColumnButton onClick={setClicked} />
      )}
    </>
  );
}
